import CenteredMessage from "@/components/CenteredMessage/CenteredMessage";

export default {
    name: "ConcreteWidget",
    props: ["rank", "updated"],
    components: {
        CenteredMessage
    },
    data() {
        return {
            busy: false
        };
    },
    watch: {
        updated: {
            handler() {
                this.busy = false;
            }
        }
    }
};
